export enum SearchRunMode {
    Manually,
    OnCriteriaChanged,
}
